<template>
	<div>
		<v-app-bar dense dark fixed color="primary" class="setClass">
			<v-toolbar-title class="text-uppercase text-h5">
				<router-link to="/dashboard"
							 tag="span"
							 style="text-decoration: none; cursor: pointer">
					<span class="setClass font-weight-bold"
						  style="color: white; text-decoration: none">Pos Demo server</span>
				</router-link>
			</v-toolbar-title>

			<v-spacer></v-spacer>
			<v-menu offset-y>
				<template v-slot:activator="{ props }">
					<div v-bind="props" class="d-flex align-center">
						<v-avatar size="30px"
								  color="blue lighten-2"
								  class="ml-2"
								  style="cursor: pointer">
							<span class="white--text">{{ nameInitials }}</span>
						</v-avatar>
						<div class="buttonDiv">
							<v-btn text class="pa-1" style="color: white">
								<span>{{ fullName }}</span>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</div>
					</div>
				</template>
				<v-list>
					<v-list-item v-for="item in menuItems"
								 :key="item.title"
								 router
								 dense
								 :to="item.route"
								 :prepend-icon="item.icon"
								 :title="item.title">
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<ProgressBar />
		<v-navigation-drawer expand-on-hover permanent rail>
			<v-list-item v-for="item in navItems"
						 :key="item.title"
						 :to="item.route"
						 :prepend-icon="item.icon"
						 :title="item.title">
			</v-list-item>
		</v-navigation-drawer>
		
	</div>
</template>

<script>
import ProgressBar from "@/components/TheProgressBar";
import { mapState, mapGetters } from "vuex";
import "@mdi/font/css/materialdesignicons.css";

export default {
	components: {
		ProgressBar,
	},
	computed: {
		...mapGetters("account", ["nameInitials"]),
		...mapState({
			fullName: (state) =>
				state.account.user ? state.account.user.fullName : "",
		}),
		getSlotName() {
			return "activator";
		},
	},
	data() {
		return {
			openMenu: false,
			navItems: [
				{ icon: "mdi-view-dashboard", title: "Dashboard", route: "/dashboard" },
				{ icon: "mdi-graph", title: "Graphs", route: "/graphs" },
				{ icon: "mdi-note-text-outline ", title: "Logs", route: "/logs" },
				{
					icon: "mdi-cash-multiple",
					title: "Transactions",
					route: "/transactions",
				},
				{ icon: "mdi-cog", title: "Settings", route: "/settings" },
				{ icon: "mdi-code-tags", title: "ResponseCode", route: "/responscode" },
				{
					icon: "mdi-currency-usd",
					title: "RulesByAmount",
					route: "/rulesbyamount",
				},
				{ icon: "mdi-point-of-sale", title: "Terminal", route: "/terminals" },
				{ icon: "mdi-protocol", title: "Protocols", route: "/protocol" },
			],
			menuItems: [
				{ icon: "mdi-account", title: "Profile", route: "/profile" },
				// { icon: "perm_identity", text: "Register", route: "/register" },
				{
					icon: "mdi-account",
					title: "User managment",
					route: "/usermanagment",
				},
				{ icon: "mdi-logout", title: "Sign Out", route: "/login" },
			],
		};
	},
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Varela+Round");

.buttonDiv {
	display: flex;
	justify-content: left;
	position: fixed;
}
.setClass {
	font-family: "Varela Round", Arial, Helvetica, sans-serif;
}
.myMenu {
	display: flex;
	justify-content: right;
	position: fixed;
	right: 315px;
	top: 50px;
	overflow: hidden;
}

.menu-container {
	display: flex;
	align-items: right;
	position: relative;
}

.menu-card {
	position: absolute;
	right: 0;
	margin-top: 8px; /* Adjust the margin as needed */
	min-width: 200px; /* Adjust the width as needed */
}

.custom-margin {
	margin-right: 15px;
}
:deep(.v-toolbar__content) {
     max-width: 1185px;
     margin: auto;
   }

:deep(.v-toolbar__items > a.v-btn--active) {
	.v-btn__content span {
        font-weight: bold;
        }
    }

:deep(.v-toolbar__items > a.v-btn--active::after) {
     content: "";
     position: absolute;
     left: 18px;
     bottom: 0;
     height: 2px;
     width: 75%;
     border-bottom: 2px solid #1e88e5;
    }

:deep(.v-btn::before) {
    background-color: transparent !important;
    }


</style>
